import { Row, Col, Card } from "react-bootstrap";
import { Shield } from "react-feather";

export default function SecureStatementNotice() {
  return (
    <Card
      className="border-0 mb-0"
      style={{
        backgroundColor: "#EBF8E6", // light green like screenshot
        borderRadius: "20px",
      }}
    >
      <Card.Body>
        <Row className="align-items-left">
          <Col xs="auto" className="m-0 p-0">
            <div
              style={{
                backgroundColor: "transparent",
                paddingRight: "10px",
                paddingLeft: "5px",
                borderRadius: "12px",
              }}
            >
              <Shield size={40} color="#4A9F3D" />
            </div>
          </Col>

          <Col className="pl-0">
            <p className="mb-0 font7 text-left" style={{ color: "#1A3C74", lineHeight: "1.5" }}>
              <b>This is a 100% secure and automated process.</b> Your data stays private and secure.
            </p>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
}
